import React from 'react';

export const Loading: React.FC = () => {
  return <div>LOADING...</div>;
};
